import { AdvisorMode } from "@omni/types/components/aiden/advisorMode.enum";
import { AdvisorType } from "@omni/types/components/aiden/advisorType.enum";
import { ImageLinkProps } from "@omni/types/components/props/imageLink.props";
import { cn } from "@omni/utils/styles";

import { useClickTracking } from "@/utils/hooks/tracking/useClickTracking.hook";
import { useImpressionTracking } from "@/utils/hooks/tracking/useImpressionTracking.hook";

import { ImageDefault } from "../Image/image.default";

export const ImageLink = ({
    href,
    openInNewTab,
    advisorId,
    advisorType,
    advisorMode,
    trackingProps,
    intersectionOptions,
    className,
    ...imageProps
}: ImageLinkProps) => {
    const { ref } = useImpressionTracking(trackingProps, intersectionOptions);
    const { onClick } = useClickTracking(trackingProps);

    if (advisorId && advisorType) {
        const advisorModeAttribute =
            advisorMode === AdvisorMode.Classic ? "sidebar" : "agent-sidebar";

        return (
            <button
                ref={ref}
                onClick={onClick}
                type={"button"}
                data-advisor-id={advisorId}
                data-aiden-mode={advisorModeAttribute}
                className={cn("tw:mb-4 tw:block", className)}
                {...(advisorType === AdvisorType.ProductCheck && {
                    "data-product-check": ""
                })}
            >
                <ImageDefault {...imageProps} />
            </button>
        );
    } else {
        return (
            <a
                href={href}
                target={openInNewTab ? "_blank" : undefined}
                ref={ref}
                className={cn("tw:mb-4 tw:block", className)}
                onClick={onClick}
            >
                <ImageDefault {...imageProps} />
            </a>
        );
    }
};
